var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Deadline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-deadline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7031",
    "data-name": "Rectangle 7031",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pending",
    d: "M11.272,18.986a.782.782,0,1,1,.2,1.55,10.505,10.505,0,0,1-2.047.062A10.117,10.117,0,1,1,12.93.786a10.038,10.038,0,0,1,2.12.885l-.2-.522a.848.848,0,1,1,1.584-.6l.843,2.206a.862.862,0,0,1,.055.262.846.846,0,0,1-.589.942l-2.258.691a.845.845,0,0,1-.491-1.617l.186-.057a8.556,8.556,0,1,0-4.721,16.06,8.935,8.935,0,0,0,1.813-.047Zm-2.7-12.6a.782.782,0,0,1,1.564,0v4.759l3.258,1.432a.781.781,0,1,1-.629,1.43L9.075,12.39a.783.783,0,0,1-.507-.732V6.389ZM14,18.15a.782.782,0,1,0,.707,1.395,9.974,9.974,0,0,0,1.443-.887.782.782,0,1,0-.932-1.256A8.387,8.387,0,0,1,14,18.15Zm3.19-2.8a.782.782,0,1,0,1.3.872,10.154,10.154,0,0,0,.825-1.478.782.782,0,1,0-1.425-.644A8.567,8.567,0,0,1,17.186,15.348Zm1.437-4.01a.782.782,0,1,0,1.557.147A10.34,10.34,0,0,0,20.2,9.8a.782.782,0,1,0-1.56.11,8.73,8.73,0,0,1-.02,1.433Zm-.648-4.206a.782.782,0,0,0,1.437-.618,10.137,10.137,0,0,0-.793-1.494.782.782,0,0,0-1.315.847A8.536,8.536,0,0,1,17.974,7.132Z",
    transform: "translate(2 2)",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Deadline);
export default __webpack_public_path__ + "static/media/icon-24-deadline.6c39bf948b511ca3f41bf53a957fad71.svg";
export { ForwardRef as ReactComponent };